export class AuthenticationRoutesNames {

  static readonly authenticationModuleName = 'authentication/';

  static readonly welcome = 'welcome';

  static readonly share = 'share';
  static readonly handover = 'handover';

  static readonly login = 'login';
  static readonly selectDatabase = 'select-database';

  static readonly createAccount = 'create-account';
  static readonly createAccountConfirmation = 'create-account-confirmation';

  static readonly resetPassword = 'reset-password';
  static readonly resetPasswordConfirmation = 'reset-password-confirmation';

  static readonly setNewPassword = 'set-new-password';
  static readonly setNewPasswordConfirmation = 'set-new-password-confirmation';

  static readonly logout = 'logout';

  static getFullName(namePart: string) {
    return AuthenticationRoutesNames.authenticationModuleName + namePart;
  }
}
